(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oss-featured-collection-08"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-oss-collection-featured-9]').forEach(function (root) {
    if (root.dataset.init) return;
    root.dataset.init = '1';

    var chips = root.querySelectorAll('[data-filter]');
    var items = root.querySelectorAll('[data-item]');
    var empty = root.querySelector('[data-empty]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-filter');
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        var shown = 0;
        items.forEach(function (it) {
          var tags = (it.getAttribute('data-tags') || '').split(' ');
          var show = f === '*' || tags.indexOf(f) > -1;
          it.classList.toggle('is-hidden', !show);
          if (show) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      });
    });

    var toast = root.querySelector('[data-toast]');
    var toastTimer;
    function showToast(msg) {
      if (!toast || !msg) return;
      toast.textContent = msg;
      toast.classList.add('is-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-show'); }, 2600);
    }

    root.querySelectorAll('[data-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        var url = btn.getAttribute('data-product-url');
        if (!id) { window.location.href = url; return; }
        btn.classList.add('is-loading');
        fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-done');
            var txt = btn.querySelector('.oss-collection-featured-9__add-txt');
            var prev = txt ? txt.textContent : '';
            if (txt) txt.textContent = root.dataset.addedText || prev;
            showToast(root.dataset.toastText);
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () {
              btn.classList.remove('is-done');
              if (txt) txt.textContent = prev;
            }, 2200);
            if (root.dataset.redirect === 'true') {
              setTimeout(function () { window.location.href = root.dataset.cartUrl; }, 500);
            }
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            window.location.href = url;
          });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oss-section-before-after-01"] && !Shopify.designMode) return;
  try {
    
  const selector = '[data-oss-section-before-after]';

  const init = (root) => {
    if (!root || root.hasAttribute('data-oss-before-after-ready')) return;

    const frame = root.querySelector('[data-oss-before-after-frame]');
    const handle = root.querySelector('[data-oss-before-after-handle]');
    if (!frame || !handle) return;

    root.setAttribute('data-oss-before-after-ready', '');

    const setPos = (pct) => {
      const value = Math.max(0, Math.min(100, pct));
      root.style.setProperty('--oss-section-before-after-pos', value + '%');
      handle.setAttribute('aria-valuenow', String(Math.round(value)));
    };

    const getPct = (clientX) => {
      const rect = frame.getBoundingClientRect();
      if (rect.width === 0) return 50;
      const clamped = Math.min(Math.max(clientX, rect.left), rect.right);
      return ((clamped - rect.left) / rect.width) * 100;
    };

    let dragging = false;

    const onPointerDown = (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      frame.setPointerCapture(event.pointerId);
      root.classList.add('is-dragging');
      handle.focus({ preventScroll: true });
      setPos(getPct(event.clientX));
      event.preventDefault();
    };

    const onPointerMove = (event) => {
      if (!dragging) return;
      setPos(getPct(event.clientX));
    };

    const stopDrag = () => {
      dragging = false;
      root.classList.remove('is-dragging');
    };

    frame.addEventListener('pointerdown', onPointerDown);
    frame.addEventListener('pointermove', onPointerMove);
    frame.addEventListener('pointerup', stopDrag);
    frame.addEventListener('pointercancel', stopDrag);

    handle.addEventListener('keydown', (event) => {
      const step = event.shiftKey ? 10 : 2;
      const current = parseFloat(getComputedStyle(root).getPropertyValue('--oss-section-before-after-pos')) || 50;

      if (event.key === 'ArrowLeft') {
        setPos(current - step);
        event.preventDefault();
      } else if (event.key === 'ArrowRight') {
        setPos(current + step);
        event.preventDefault();
      } else if (event.key === 'Home') {
        setPos(0);
        event.preventDefault();
      } else if (event.key === 'End') {
        setPos(100);
        event.preventDefault();
      }
    });
  };

  const initAll = () => {
    document.querySelectorAll(selector).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector(selector) || event.target;
    if (section.matches && section.matches(selector)) init(section);
  });

  } catch(e) { console.error(e); }
})();
})();
